class CollectionNav extends HTMLElement {
  constructor() {
    super();
    this.preview = null;
    this.previewImage = null;
    this.triggers = [];
    this.hoverQuery = null;
    this.hoverEnabled = false;
    this.onTriggerEnter = this.onTriggerEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onHoverChange = this.onHoverChange.bind(this);
  }

  connectedCallback() {
    this.preview = this.querySelector("[data-category-preview]");
    this.previewImage = this.querySelector("[data-category-preview-image]");
    this.triggers = Array.from(
      this.querySelectorAll("[data-category-trigger]")
    );

    this.hoverQuery = window.matchMedia("(hover: hover) and (pointer: fine)");
    this.hoverEnabled = this.hoverQuery.matches;
    this.toggleHoverBindings(this.hoverEnabled);
    this.hoverQuery.addEventListener("change", this.onHoverChange);
    this.scrollActiveIntoView();
  }

  scrollActiveIntoView() {
    const active = this.querySelector('[aria-current="page"]');
    if (!active) return;
    const container =
      active.closest("[data-category-nav-list]") ||
      active.closest(".collection-banner__nav-list");
    if (!container) return;
    const scrollLeft =
      active.offsetLeft - container.offsetWidth / 2 + active.offsetWidth / 2;
    container.scrollTo({ left: Math.max(0, scrollLeft), behavior: "smooth" });
  }

  disconnectedCallback() {
    this.toggleHoverBindings(false);
    if (this.hoverQuery) {
      this.hoverQuery.removeEventListener("change", this.onHoverChange);
      this.hoverQuery = null;
    }
  }

  onHoverChange(event) {
    this.hoverEnabled = event.matches;
    this.toggleHoverBindings(this.hoverEnabled);
    if (!this.hoverEnabled) {
      this.hidePreview();
    }
  }

  toggleHoverBindings(enable) {
    this.triggers.forEach((trigger) => {
      if (enable) {
        trigger.addEventListener("mouseenter", this.onTriggerEnter);
      } else {
        trigger.removeEventListener("mouseenter", this.onTriggerEnter);
      }
    });
    if (enable) {
      this.addEventListener("mouseleave", this.onMouseLeave);
      this.addEventListener("mousemove", this.onMouseMove);
    } else {
      this.removeEventListener("mouseleave", this.onMouseLeave);
      this.removeEventListener("mousemove", this.onMouseMove);
    }
  }

  onTriggerEnter(event) {
    if (!this.preview || !this.previewImage) return;
    const trigger = event.currentTarget;
    const image = trigger.dataset.categoryImage;
    const name = trigger.dataset.categoryName || "";
    if (!image) {
      this.hidePreview();
      return;
    }
    this.previewImage.src = image;
    this.previewImage.alt = name;
    this.preview.classList.remove("opacity-0");
    this.preview.classList.add("opacity-100");
    this.preview.setAttribute("aria-hidden", "false");
  }

  onMouseMove(event) {
    if (!this.preview) return;
    if (this.preview.classList.contains("opacity-0")) return;
    const offset = 20;
    this.preview.style.left = `${event.clientX}px`;
    this.preview.style.top = `${event.clientY - offset}px`;
    this.preview.style.transform = "translate(-50%, -100%)";
  }

  onMouseLeave() {
    this.hidePreview();
  }

  hidePreview() {
    if (!this.preview) return;
    this.preview.classList.add("opacity-0");
    this.preview.classList.remove("opacity-100");
    this.preview.setAttribute("aria-hidden", "true");
  }
}

if (!customElements.get("collection-nav")) {
  customElements.define("collection-nav", CollectionNav);
}
